import React from "react";
import './KiVideo.scss';

export default function KiVideo() {
	return (
		<div className="KiVideo">
			<h2>Se Anine og Atle demonstrere KI-søket i Lovdata Pro 2</h2>
			<div className="video">
				<iframe
					src="https://player.vimeo.com/video/1093637121?autoplay=0&muted=0&loop=1&badge=0&autopause=0&player_id=0&app_id=58479"
					frameBorder="0"
					allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media"
					title="Lovdata KI - kort"
				></iframe>
			</div>
			<p>Anine Svarstad (Digitaliseringsjurist) og Atle Oftedahl (Lead Data Scientist)</p>
		</div>
	);
}